var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IdBuilding } from "../../../constants/IdBuilding";
import { GetDirtCornerIso } from "../../../graphics/fence/GetDirtCornerIso";
import { GetDirtPieceIso } from "../../../graphics/fence/GetDirtPieceIso";
import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { selectExpansionInfo } from "../../../selectors/selectExpansionInfo";
import { IdAssetBundleCore } from "../../loading/IdAssetBundleCore";
import { LayerPlayerBaseSurrounding, } from "./LayerPlayerBaseSurrounding";
var LayerPlayerBaseDirt = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseDirt, _super);
    function LayerPlayerBaseDirt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mapState = function (state) {
            var fenceBundle = state.loading.bundles[IdAssetBundleCore.Fence] || { isLoaded: false };
            return {
                areAssetsLoaded: fenceBundle.isLoaded,
                expansionInfo: selectExpansionInfo(state),
                fence: selectBuildingInfoByTypeId(state, IdBuilding.Fence),
                getCornerPillarIso: GetDirtCornerIso,
                getPieceIso: GetDirtPieceIso,
                getPillarIso: function () { return undefined; },
            };
        };
        _this.mapDispatch = function (dispatch) { return ({
            onSelect: function (building, pos) { return undefined; },
        }); };
        return _this;
    }
    return LayerPlayerBaseDirt;
}(LayerPlayerBaseSurrounding));
export { LayerPlayerBaseDirt };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseDirt.ts
// module id = 2211
// module chunks = 3